const allColors = [
    {
        name: "Black",
        variable: "Variables.Colors.Black",
        css: "var(--color-black)",
        hex: "#000000",
        rgb: "rgb(0, 0, 0)",
    },
    {
        name: "White",
        variable: "Variables.Colors.White",
        css: "var(--color-white)",
        hex: "#FFFFFF",
        rgb: "rgb(255, 255, 255)",
    },
    {
        name: "Gray 50",
        variable: "Variables.Colors.Gray50",
        css: "var(--color-gray-50)",
        hex: "#F8F8F8",
        rgb: "rgb(248, 248, 248)",
    },
    {
        name: "Gray 100",
        variable: "Variables.Colors.Gray100",
        css: "var(--color-gray-100)",
        hex: "#E4E4E4",
        rgb: "rgb(228, 228, 228)",
    },
    {
        name: "Gray 200",
        variable: "Variables.Colors.Gray200",
        css: "var(--color-gray-200)",
        hex: "#C8C8C8",
        rgb: "rgb(200, 200, 200)",
    },
    {
        name: "Gray 300",
        variable: "Variables.Colors.Gray300",
        css: "var(--color-gray-300)",
        hex: "#ADADAD",
        rgb: "rgb(173, 173, 173)",
    },
    {
        name: "Gray 400",
        variable: "Variables.Colors.Gray400",
        css: "var(--color-gray-400)",
        hex: "#919191",
        rgb: "rgb(145, 145, 145)",
    },
    {
        name: "Gray 500",
        variable: "Variables.Colors.Gray500",
        css: "var(--color-gray-500)",
        hex: "#767676",
        rgb: "rgb(118, 118, 118)",
    },
    {
        name: "Gray 600",
        variable: "Variables.Colors.Gray600",
        css: "var(--color-gray-600)",
        hex: "#5E5E5E",
        rgb: "rgb(94, 94, 94)",
    },
    {
        name: "Gray 700",
        variable: "Variables.Colors.Gray700",
        css: "var(--color-gray-700)",
        hex: "#474747",
        rgb: "rgb(71, 71, 71)",
    },
    {
        name: "Gray 800",
        variable: "Variables.Colors.Gray800",
        css: "var(--color-gray-800)",
        hex: "#2F2F2F",
        rgb: "rgb(47, 47, 47)",
    },
    {
        name: "Gray 900",
        variable: "Variables.Colors.Gray900",
        css: "var(--color-gray-900)",
        hex: "#181818",
        rgb: "rgb(24, 24, 24)",
    },
    {
        name: "Primary 50",
        variable: "Variables.Colors.Primary50",
        css: "var(--color-primary-50)",
        hex: "#F4F6F7",
        rgb: "rgb(244, 246, 247)",
    },
    {
        name: "Primary 100",
        variable: "Variables.Colors.Primary100",
        css: "var(--color-primary-100)",
        hex: "#D1DAE1",
        rgb: "rgb(209, 218, 225)",
    },
    {
        name: "Primary 200",
        variable: "Variables.Colors.Primary200",
        css: "var(--color-primary-200)",
        hex: "#A4B5C3",
        rgb: "rgb(164, 181, 195)",
    },
    {
        name: "Primary 300",
        variable: "Variables.Colors.Primary300",
        css: "var(--color-primary-300)",
        hex: "#768FA4",
        rgb: "rgb(118, 143, 164)",
    },
    {
        name: "Primary 400",
        variable: "Variables.Colors.Primary400",
        css: "var(--color-primary-400)",
        hex: "#496A86",
        rgb: "rgb(73, 106, 134)",
    },
    {
        name: "Primary 500",
        variable: "Variables.Colors.Primary500",
        css: "var(--color-primary-500)",
        hex: "#1B4568",
        rgb: "rgb(27, 69, 104)",
    },
    {
        name: "Primary 600",
        variable: "Variables.Colors.Primary600",
        css: "var(--color-primary-600)",
        hex: "#163753",
        rgb: "rgb(22, 55, 83)",
    },
    {
        name: "Primary 700",
        variable: "Variables.Colors.Primary700",
        css: "var(--color-primary-700)",
        hex: "#10293E",
        rgb: "rgb(16, 41, 62)",
    },
    {
        name: "Primary 800",
        variable: "Variables.Colors.Primary800",
        css: "var(--color-primary-800)",
        hex: "#0B1C2A",
        rgb: "rgb(11, 28, 42)",
    },
    {
        name: "Primary 900",
        variable: "Variables.Colors.Primary900",
        css: "var(--color-primary-900)",
        hex: "#050E15",
        rgb: "rgb(5, 14, 21)",
    },
    {
        name: "Secondary 50",
        variable: "Variables.Colors.Secondary50",
        css: "var(--color-secondary-50)",
        hex: "#F4F8FD",
        rgb: "rgb(244, 248, 253)",
    },
    {
        name: "Secondary 100",
        variable: "Variables.Colors.Secondary100",
        css: "var(--color-secondary-100)",
        hex: "#D4E2F6",
        rgb: "rgb(212, 226, 246)",
    },
    {
        name: "Secondary 200",
        variable: "Variables.Colors.Secondary200",
        css: "var(--color-secondary-200)",
        hex: "#A8C5ED",
        rgb: "rgb(168, 197, 237)",
    },
    {
        name: "Secondary 300",
        variable: "Variables.Colors.Secondary300",
        css: "var(--color-secondary-300)",
        hex: "#7DA7E5",
        rgb: "rgb(125, 167, 229)",
    },
    {
        name: "Secondary 400",
        variable: "Variables.Colors.Secondary400",
        css: "var(--color-secondary-400)",
        hex: "#518ADC",
        rgb: "rgb(81, 138, 220)",
    },
    {
        name: "Secondary 500",
        variable: "Variables.Colors.Secondary500",
        css: "var(--color-secondary-500)",
        hex: "#266DD3",
        rgb: "rgb(38, 109, 211)",
    },
    {
        name: "Secondary 600",
        variable: "Variables.Colors.Secondary600",
        css: "var(--color-secondary-600)",
        hex: "#1E57A9",
        rgb: "rgb(30, 87, 169)",
    },
    {
        name: "Secondary 700",
        variable: "Variables.Colors.Secondary700",
        css: "var(--color-secondary-700)",
        hex: "#17417F",
        rgb: "rgb(23, 65, 127)",
    },
    {
        name: "Secondary 800",
        variable: "Variables.Colors.Secondary800",
        css: "var(--color-secondary-800)",
        hex: "#0F2C54",
        rgb: "rgb(15, 44, 84)",
    },
    {
        name: "Secondary 900",
        variable: "Variables.Colors.Secondary900",
        css: "var(--color-secondary-900)",
        hex: "#08162A",
        rgb: "rgb(8, 22, 42)",
    },
    {
        name: "Success 50",
        variable: "Variables.Colors.Success50",
        css: "var(--color-success-50)",
        hex: "#F3F9F6",
        rgb: "rgb(243, 249, 246)",
    },
    {
        name: "Success 100",
        variable: "Variables.Colors.Success100",
        css: "var(--color-success-100)",
        hex: "#CEE6DB",
        rgb: "rgb(206, 230, 219)",
    },
    {
        name: "Success 200",
        variable: "Variables.Colors.Success200",
        css: "var(--color-success-200)",
        hex: "#9DCDB7",
        rgb: "rgb(157, 205, 183)",
    },
    {
        name: "Success 300",
        variable: "Variables.Colors.Success300",
        css: "var(--color-success-300)",
        hex: "#6BB392",
        rgb: "rgb(107, 179, 146)",
    },
    {
        name: "Success 400",
        variable: "Variables.Colors.Success400",
        css: "var(--color-success-400)",
        hex: "#3A9A6E",
        rgb: "rgb(58, 154, 110)",
    },
    {
        name: "Success 500",
        variable: "Variables.Colors.Success500",
        css: "var(--color-success-500)",
        hex: "#09814A",
        rgb: "rgb(9, 129, 74)",
    },
    {
        name: "Success 600",
        variable: "Variables.Colors.Success600",
        css: "var(--color-success-600)",
        hex: "#07673B",
        rgb: "rgb(7, 103, 59)",
    },
    {
        name: "Success 700",
        variable: "Variables.Colors.Success700",
        css: "var(--color-success-700)",
        hex: "#054D2C",
        rgb: "rgb(5, 77, 44)",
    },
    {
        name: "Success 800",
        variable: "Variables.Colors.Success800",
        css: "var(--color-success-800)",
        hex: "#04341E",
        rgb: "rgb(4, 52, 30)",
    },
    {
        name: "Success 900",
        variable: "Variables.Colors.Success900",
        css: "var(--color-success-900)",
        hex: "#021A0F",
        rgb: "rgb(2, 26, 15)",
    },
    {
        name: "Danger 50",
        variable: "Variables.Colors.Danger50",
        css: "var(--color-danger-50)",
        hex: "#FBF2F4",
        rgb: "rgb(251, 242, 244)",
    },
    {
        name: "Danger 100",
        variable: "Variables.Colors.Danger100",
        css: "var(--color-danger-100)",
        hex: "#F0CCD1",
        rgb: "rgb(240, 204, 209)",
    },
    {
        name: "Danger 200",
        variable: "Variables.Colors.Danger200",
        css: "var(--color-danger-200)",
        hex: "#E199A4",
        rgb: "rgb(225, 153, 164)",
    },
    {
        name: "Danger 300",
        variable: "Variables.Colors.Danger300",
        css: "var(--color-danger-300)",
        hex: "#D16676",
        rgb: "rgb(209, 102, 118)",
    },
    {
        name: "Danger 400",
        variable: "Variables.Colors.Danger400",
        css: "var(--color-danger-400)",
        hex: "#C23349",
        rgb: "rgb(194, 51, 73)",
    },
    {
        name: "Danger 500",
        variable: "Variables.Colors.Danger500",
        css: "var(--color-danger-500)",
        hex: "#B3001B",
        rgb: "rgb(179, 0, 27)",
    },
    {
        name: "Danger 600",
        variable: "Variables.Colors.Danger600",
        css: "var(--color-danger-600)",
        hex: "#8F0016",
        rgb: "rgb(143, 0, 22)",
    },
    {
        name: "Danger 700",
        variable: "Variables.Colors.Danger700",
        css: "var(--color-danger-700)",
        hex: "#6B0010",
        rgb: "rgb(107, 0, 16)",
    },
    {
        name: "Danger 800",
        variable: "Variables.Colors.Danger800",
        css: "var(--color-danger-800)",
        hex: "#48000B",
        rgb: "rgb(72, 0, 11)",
    },
    {
        name: "Danger 900",
        variable: "Variables.Colors.Danger900",
        css: "var(--color-danger-900)",
        hex: "#240005",
        rgb: "rgb(36, 0, 5)",
    },
    {
        name: "Warning 50",
        variable: "Variables.Colors.Warning50",
        css: "var(--color-warning-50)",
        hex: "#FCF6F2",
        rgb: "rgb(252, 246, 242)",
    },
    {
        name: "Warning 100",
        variable: "Variables.Colors.Warning100",
        css: "var(--color-warning-100)",
        hex: "#F3DBCC",
        rgb: "rgb(243, 219, 204)",
    },
    {
        name: "Warning 200",
        variable: "Variables.Colors.Warning200",
        css: "var(--color-warning-200)",
        hex: "#E7B699",
        rgb: "rgb(231, 182, 153)",
    },
    {
        name: "Warning 300",
        variable: "Variables.Colors.Warning300",
        css: "var(--color-warning-300)",
        hex: "#DC9266",
        rgb: "rgb(220, 146, 102)",
    },
    {
        name: "Warning 400",
        variable: "Variables.Colors.Warning400",
        css: "var(--color-warning-400)",
        hex: "#D06D33",
        rgb: "rgb(208, 109, 51)",
    },
    {
        name: "Warning 500",
        variable: "Variables.Colors.Warning500",
        css: "var(--color-warning-500)",
        hex: "#C44900",
        rgb: "rgb(196, 73, 0)",
    },
    {
        name: "Warning 600",
        variable: "Variables.Colors.Warning600",
        css: "var(--color-warning-600)",
        hex: "#9D3A00",
        rgb: "rgb(157, 58, 0)",
    },
    {
        name: "Warning 700",
        variable: "Variables.Colors.Warning700",
        css: "var(--color-warning-700)",
        hex: "#762C00",
        rgb: "rgb(118, 44, 0)",
    },
    {
        name: "Warning 800",
        variable: "Variables.Colors.Warning800",
        css: "var(--color-warning-800)",
        hex: "#4E1D00",
        rgb: "rgb(78, 29, 0)",
    },
    {
        name: "Warning 900",
        variable: "Variables.Colors.Warning900",
        css: "var(--color-warning-900)",
        hex: "#270F00",
        rgb: "rgb(39, 15, 0)",
    },
]

export default allColors
